import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { DLSelect, DLTextField, Checkbox } from 'appSrc/components/UI';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import AllListsTable from './Table';
import { showModal, hideModal } from 'appSrc/redux/actions';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class AllListsView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            lists: [],
            searchValue: '',
        };

        this.listQueryObject = {
            page: 1,
            limit: 200,
            sort: 'title,listid',
            search: undefined,
        };
    }
    componentDidMount() {
        this.loadLists();
    }
    updateSearch = ( e, { value } ) => {
        this.setState( { searchValue: value } );
    }
    onSearchKeyDown = ( e ) => {
        if( e.keyCode == 13 ) {
            e.preventDefault();
            this.listQueryObject.page = 1;
            this.listQueryObject.search = this.state.searchValue || undefined;
            this.setState( {
                fetching: true,
                lists: [],
            } );
            this.loadLists();
        }
    }
    onFilter = ( key, value ) => {
        this.listQueryObject.page = 1;
        this.listQueryObject[ key ] = value;
        this.setState( {
            fetching: true,
            lists: [],
        } );
        this.loadLists();
    }
    onColumnSort = ( value ) => {
        if( this.listQueryObject.sort == value ) {
            value = `-${ value }`;
        }
        this.listQueryObject.page = 1;
        this.listQueryObject.sort = value;

        this.setState( {
            fetching: true,
            lists: [],
        } );
        this.loadLists();
    }
    loadLists = () => {
        return this.props.getLists( this.listQueryObject )
        .then( ( lists ) => {
            this.listQueryObject.page++;

            this.setState( ( prevState ) => {
                prevState.fetching = false;
                prevState.lists = prevState.lists.concat( lists );
                return prevState;
            } );
            return lists;
        } );
    }
    listUpdated = ( index, list ) => {
        this.setState( ( altState ) => {
            altState.lists[ index ] = list;
            altState.lists = altState.lists.slice( 0 );
            return altState;
        } );
    }
    listDeleted = ( index ) => {
        this.setState( ( altState ) => {
            altState.lists = altState.lists.slice( 0, index ).concat( altState.lists.slice( index + 1 ) );
            return altState;
        } );
    }

    render() {
        const { fetching, lists, searchValue } = this.state;
        var filterCategoryOptions = this.props.interestOptions.reduce( ( agg, curr ) => {
            agg.push( {
                text: curr.interest,
                value: curr.interestid,
            } );
            return agg;
        }, [ { text: '', value: null } ] );

        return (
            <section className={ style.page }>
                <div className={ style.head }>
                    <h2>Lists</h2>
                    <div className={ style.controls }>
                        <DLTextField className={ style.searchBar }
                        placeholder='Search'
                        value={ searchValue }
                        onChange={ this.updateSearch }
                        onKeyDown={ this.onSearchKeyDown }
                        noError />
                    </div>
                    <div className={ style.tabs }>
                        <Link to='/admin/lists' className={ style.tabOption }
                        data-active={ true }>View All</Link>
                        <Link to='/admin/lists/featured' className={ style.tabOption }>Featured Lists</Link>
                    </div>
                </div>
                <div className={ style.body }>
                    <section className={ style.allList }>
                        <div className={ style.filters }>
                            <span style={ { marginRight: '20px' } }>Filter By</span>

                            <Checkbox label='Featured'
                            checked={ !!this.listQueryObject[ 'featured' ] }
                            onChange={ ( e, newValue ) => { this.onFilter( 'featured', newValue || undefined ); } }
                            style={ { marginRight: '20px' } } />

                            <DLSelect placeholder='Channel' options={ filterCategoryOptions }
                            value={ this.listQueryObject[ 'interestid' ] }
                            onChange={ ( e, { value } ) => { this.onFilter( 'interestid', value ); } }
                            style={ { width: '170px' } }
                            noError />
                        </div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <AllListsTable
                            lists={ lists }
                            currentSort={ this.listQueryObject.sort }
                            loadMore={ this.loadLists }
                            onColumnSort={ this.onColumnSort }
                            onListUpdated={ this.listUpdated }
                            onListDeleted={ this.listDeleted }
                            elementHeight={ 70 } />
                        }
                    </section>
                </div>
            </section>
        );
    }
}

const mapStateToProps = ( state ) => {
    return {
        interestOptions: state.vars.interests,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        showModal: ( modalName ) => {
            dispatch( showModal( modalName ) );
        },
        hideModal: ( modalName ) => {
            dispatch( hideModal( modalName ) );
        },
        getLists: ( queryObject ) => {
            return dAPI.get( '/admin/lists', queryObject );

        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( AllListsView );
